import { useParams } from "react-router-dom";
import { getUserLang, isNullOrEmpty } from "../../lib/helper";
import { useInjectedService } from "../../services/ioc/service-dependency";
import AppContainer from "../app-container/app-container";

import './recommended.css';

const Recommended = () => {

    const { localizationService } = useInjectedService();

    let { culture, location } = useParams();

    if (
        isNullOrEmpty(culture) ||
        culture === undefined
    ) {
        culture = getUserLang();
    }

    let faqUrl = "";
    if (!isNullOrEmpty(culture) && culture !== undefined && localizationService.isValidCulture(culture)) {
        faqUrl = "/" + culture;
    }
    if (!isNullOrEmpty(location) && location !== undefined && localizationService.isValidCountry(location)) {
        faqUrl += "/" + location;
    }
    faqUrl += "/faq" + window.location.search;

    let bkcAppUrl = "";
    if (!isNullOrEmpty(culture) && culture !== undefined && localizationService.isValidCulture(culture)) {
        bkcAppUrl = "/" + culture;
    }
    if (!isNullOrEmpty(location) && location !== undefined && localizationService.isValidCountry(location)) {
        bkcAppUrl += "/" + location;
    }
    bkcAppUrl += "/bkcapp" + window.location.search;


    return <div>
        <div className="row">
            <div className="col-sm">
                <div className="bbraun-hero bbraun-prepare-hero">
                    <div className="bbraun-hero-subtitle">
                        {localizationService.getLocalizedText("RecommendedApps")}
                    </div>
                    <div className="bbraun-hero-headline">
                        {localizationService.getLocalizedText("RecommendedAppsLabel")}
                    </div>
                    <div className="bbraun-hero-content">
                        {localizationService.getLocalizedText("RecommendedAppsDesc")}
                    </div>
                </div>
            </div>
        </div>
        <div className="row bbraun-sand-bg">
            <div className="col-sm">
                <div className="bbraun-hero bbraun-recommended-row">
                    <div>
                        <div className="bbraun-hero-headline">
                            {localizationService.getLocalizedText("RecommendedAppsSecondLabel")}
                        </div>
                        <div className="bbraun-hero-content">
                            {localizationService.getLocalizedText("RecommendedAppsSecondDesc")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row bbraun-sand-bg">
            <div className="col-sm">
                <AppContainer
                    title={localizationService.getLocalizedText("MsftAuthenticatorApp")}
                    description={localizationService.getLocalizedText("MsftAuthenticatorAppDesc")}
                    googlePlayStoreLink={"https://play.google.com/store/apps/details?id=com.azure.authenticator"}
                    iosLink={"https://apps.apple.com/de/app/microsoft-authenticator/id983156458"}
                    icon={require("../../assets/images/AuthenticatorApp.png")}
                />
                <AppContainer
                    title={localizationService.getLocalizedText("MsftEnterpriseApp")}
                    description={localizationService.getLocalizedText("MsftEnterpriseAppDesc")}
                    googlePlayStoreLink={"https://play.google.com/store/apps/details?id=com.microsoft.windowsintune.companyportal"}
                    icon={require("../../assets/images/CompanyPortal.png")}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-sm">
                <div className="bbraun-hero bbraun-recommended-row">
                    <div>
                        <div className="bbraun-hero-headline">
                            {localizationService.getLocalizedText("RecommendedAppsThirdLabel")}
                        </div>
                        <div className="bbraun-hero-content">
                            {localizationService.getLocalizedText("RecommendedAppsThirdDesc")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row bbraun">
            <div className="col-sm">
                <AppContainer
                    title={localizationService.getLocalizedText("HRSuccessFactorsApp")}
                    description={localizationService.getLocalizedText("HRSuccessFactorsAppDesc")}
                    googlePlayStoreLink={"https://play.google.com/store/apps/details?id=com.successfactors.successfactors"}
                    iosLink={"https://apps.apple.com/us/app/sap-successfactors-mobile/id426562526"}
                    icon={require("../../assets/images/HRApp.png")}
                    additionalClassName="bbraun-bkc-app-container bbraun-app-container-icon-hrapp"
                    disableIosLink={true}
                    iconStyle={{ marginLeft: "-13px" }}
                    moreLink={"https://bbraun.sharepoint.com/sites/bbraun_intranet_corporate_apps_int"}
                    moreText={localizationService.getLocalizedText("MoreInfoText")}
                />
                <AppContainer
                    title={localizationService.getLocalizedText("BKCApp")}
                    description={localizationService.getLocalizedText("BKCAppDesc")}
                    googlePlayStoreLink={"https://play.google.com/store/apps/details?id=com.bbraun.bkc&gl=DE"}
                    iosLink={"https://apps.apple.com/de/app/bkc-app/id1597272008"}
                    icon={require("../../assets/images/BKCApp.png")}
                    additionalClassName="bbraun-bkc-app-container"
                    disableIosLink={true}
                    moreLink={bkcAppUrl}
                    moreText={localizationService.getLocalizedText("MoreInfoText")}
                />
                <AppContainer
                    title={localizationService.getLocalizedText("MsftTeamsApp")}
                    description={localizationService.getLocalizedText("MsftTeamsAppDesc")}
                    googlePlayStoreLink={"https://play.google.com/store/apps/details?id=com.microsoft.teams&hl=de&gl=US"}
                    iosLink={"https://apps.apple.com/de/app/microsoft-teams/id1113153706"}
                    icon={require("../../assets/images/TeamsApp.png")}
                />
            </div>
        </div>
        <div className="row bbraun-green-bg">
            <div className="col-sm">
                <div className="bbraun-hero">
                    <div className="bbraun-hero-headline">
                        {localizationService.getLocalizedText("FAQLabel")}
                    </div>
                    <div className="bbraun-hero-content">
                        <a className="bbraun-hero-button-link" href={faqUrl}>
                            {localizationService.getLocalizedText("FAQButtonLabel")}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}

export default Recommended;
